import React from 'react'
import { SupportStaffProvider } from '../../supportStaff'
import AdminAgencyAccessPage from './AdminAgencyAccessPage'

const AdminAgencyAccessRoute = () => (
  <SupportStaffProvider>
    <AdminAgencyAccessPage />
  </SupportStaffProvider>
)

export default AdminAgencyAccessRoute
